import * as React from "react";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { connect } from "react-redux";
import MyChartContainer from "../mychart/MyChartContainer";

class Insurance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onError: false
        };
        this.onError = this.onError.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Insurance.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    onError() {
        if (!this.state.onError) {
            this.setState({ onError: true });
        }
    }

    routeToLinkedAccounts = () => {
        logUI("MBHWeb.UI.Insurance.RouteToLinkedAccounts.Click", new Date(), Tools.getURLPath());
        this.props.history.push({
            pathname: '/linkedaccounts',
            searchParams: "openInsurance=true"
        });
    }

    render() {
        const { serverData } = this.props;
        const { onError } = this.state;
        const heading = onError ? null : (
            <div className="row">
                <div className="col-12 col-md-6">
                    <h1 className="page-heading dt-heading-line">Insurance on File</h1>
                </div>
                <div className="col-12 col-md-6 text-md-right">
                    <div className="bswh-mychart-overlay">
                        <Link className="btn btn-primary" to={{ pathname: "/coverage" }}>
                            COVERAGE
                        </Link>
                    </div>
                </div>
                <div className="col-12">
                    These are the insurance plans we have saved for you as part of your Baylor Scott & White medical record. If you are a Baylor Scott & White Health Plan, FirstCare Health Plans, or DFW Connected Care member, link your plan to your MyBSWHealth account <button className='btn text-btn' onClick={this.routeToLinkedAccounts}>here.</button>
                </div>
            </div>
        );
        return <MyChartContainer mode="insurance" title="Insurance" heading={heading} serverData={serverData} mychartError={this.onError} />;
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData
    };
};

export default connect(
    mapStateToProps
)(Insurance);